import {
  CLASS_OPTIONS,
  SPEC_OPTIONS_WARRIOR,
  SPEC_OPTIONS_ROGUE,
  SPEC_OPTIONS_PALADIN,
  SPEC_OPTIONS_WARLOCK,
  SPEC_OPTIONS_DRUID,
  SPEC_OPTIONS_DEATHKNIGHT,
  SPEC_OPTIONS_DEMON_HUNTER,
  SPEC_OPTIONS_EVOKER,
  SPEC_OPTIONS_HUNTER,
  SPEC_OPTIONS_MAGE,
  SPEC_OPTIONS_SHAMAN,
  SPEC_OPTIONS_PRIEST,
  SPEC_OPTIONS_MONK,
  RAID_DUNGEON_OPTIONS,
  MYTHIC_ENCOUNTER_OPTIONS,
  AFFIX_OPTIONS,
  PVP_GAME_MODE_OPTIONS,
  VAULT_OF_THE_INCARNATES,
  ABERRUS_OPTIONS,
  AMIRDRASSIL_OPTIONS,
} from "./filter_options";

export const validParams = {
  builds: {
    class: CLASS_OPTIONS,
    specs: {
      warrior: SPEC_OPTIONS_WARRIOR,
      rogue: SPEC_OPTIONS_ROGUE,
      paladin: SPEC_OPTIONS_PALADIN,
      warlock: SPEC_OPTIONS_WARLOCK,
      druid: SPEC_OPTIONS_DRUID,
      death_knight: SPEC_OPTIONS_DEATHKNIGHT,
      demon_hunter: SPEC_OPTIONS_DEMON_HUNTER,
      evoker: SPEC_OPTIONS_EVOKER,
      hunter: SPEC_OPTIONS_HUNTER,
      mage: SPEC_OPTIONS_MAGE,
      shaman: SPEC_OPTIONS_SHAMAN,
      priest: SPEC_OPTIONS_PRIEST,
      monk: SPEC_OPTIONS_MONK,
    },
    mythics: MYTHIC_ENCOUNTER_OPTIONS,
    raids: RAID_DUNGEON_OPTIONS,
    encounters: {
      amirdrassil: AMIRDRASSIL_OPTIONS,
    },
    encounterTypes: [
      {
        type: "raid",
        label: "Raiding",
      },
      {
        type: "",
        label: "Mythic+",
      },
    ],
    difficulty: [
      { value: "all", label: "All Difficulties" },
      // { value: "normal", label: "Normal" },
      {
        value: "heroic",
        label: "Heroic",
      },
      {
        value: "mythic",
        label: "Mythic",
      },
    ],
    affixes: AFFIX_OPTIONS,
    default: {
      difficulty: "heroic",
    },
  },
  pvp: {
    class: CLASS_OPTIONS,
    specs: {
      warrior: SPEC_OPTIONS_WARRIOR,
      rogue: SPEC_OPTIONS_ROGUE,
      paladin: SPEC_OPTIONS_PALADIN,
      warlock: SPEC_OPTIONS_WARLOCK,
      druid: SPEC_OPTIONS_DRUID,
      death_knight: SPEC_OPTIONS_DEATHKNIGHT,
      demon_hunter: SPEC_OPTIONS_DEMON_HUNTER,
      evoker: SPEC_OPTIONS_EVOKER,
      hunter: SPEC_OPTIONS_HUNTER,
      mage: SPEC_OPTIONS_MAGE,
      shaman: SPEC_OPTIONS_SHAMAN,
      priest: SPEC_OPTIONS_PRIEST,
      monk: SPEC_OPTIONS_MONK,
    },
    gameModes: PVP_GAME_MODE_OPTIONS,
  },
  tierList: {
    mythics: MYTHIC_ENCOUNTER_OPTIONS,
    raids: RAID_DUNGEON_OPTIONS,
    encounters: {
      amirdrassil: AMIRDRASSIL_OPTIONS,
    },
    default: {
      encounterType: "raid",
      difficulty: "heroic",
    },
    encounterTypes: [
      {
        type: "raid",
        label: "Raiding",
      },
      {
        type: "",
        label: "Mythic+",
      },
      {
        type: "pvp",
        label: "PvP",
      },
    ],
    difficulty: [
      { value: "all", label: "All Difficulties" },
      // { value: "normal", label: "Normal" },
      {
        value: "heroic",
        label: "Heroic",
      },
      {
        value: "mythic",
        label: "Mythic",
      },
    ],
    affixes: AFFIX_OPTIONS,
    gameModes: PVP_GAME_MODE_OPTIONS,
  },
};

export const global_exemptions = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "url",
  "gclid",
  "gtm",
  "google_preview",
  "gdfp_req",
  "lineItemId",
  "creativeId",
  "googfc",
  "iframe",
  "aps_debug",
  "aps_preview",
  "aps_pause",
  // for lngtd. Remove after they are done
  "krg_qa",
  "ad_id",
  "google_preview",
  "iu",
  "gdfp_req",
  "lineItemId",
  "creativeId",
  "testbidder",
];
